import script from "./Room.vue?vue&type=script&lang=ts&setup=true"
export * from "./Room.vue?vue&type=script&lang=ts&setup=true"

import "./Room.vue?vue&type=style&index=0&id=6c34c9c4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c34c9c4"]])

export default __exports__